<template>
  <form>
    <timezone-picker :timezone="savedTimeZone" @timezone-select="onTimeZoneSelect"></timezone-picker>

    <button
      class="button timezone-button"
      title="Use the time zone selected above"
      type="button"
      data-test="save-timezone-button"
      :disabled="!selectedTimeZone || selectedTimeZone === savedTimeZone"
      @click="onSaveClick"
    >
      Save
    </button>

    <button
      class="button timezone-button"
      title="Use the time zone from your computer"
      type="button"
      data-test="reset-timezone-button"
      :disabled="!savedTimeZone"
      @click="onResetClick"
    >
      Reset
    </button>
  </form>
</template>

<script>
import TimezonePicker from '../components/account/timezone/TimezonePicker';
import {updateUserTimeZone} from '../utility/api/config/updateUserTimeZone';
import {showProfileLockedWarning} from '../utility/showProfileLockedWarning';

export default {
  name: 'account-timezone-page',
  components: {TimezonePicker},
  props: {
    timezone: {
      type: String,
      required: true,
    },
    profileLocked: {
      type: Boolean,
      required: true,
      default: false,
    },
    profileApproved: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      savedTimeZone: '',
      selectedTimeZone: '',
    };
  },
  watch: {
    timezone: {
      immediate: true,
      handler(value) {
        this.savedTimeZone = value;
      },
    },
  },
  methods: {
    async updateUserTimeZone(timezone) {
      await showProfileLockedWarning.warning(this.profileLocked);
      this.savedTimeZone = await updateUserTimeZone(timezone);
      $.notify('Your time zone has been saved!', 'success');
    },
    onTimeZoneSelect(value) {
      this.selectedTimeZone = value;
    },
    onSaveClick() {
      this.updateUserTimeZone(this.selectedTimeZone);
    },
    onResetClick() {
      this.selectedTimeZone = '';
      this.updateUserTimeZone(this.selectedTimeZone);
    },
  },
};
</script>

<style lang="scss" scoped>
.timezone-button {
  margin-right: 10px;
}
</style>
